export default "__VITE_ASSET__Dehj7wVc__"